import { render, staticRenderFns } from "./staffAttachmentsComponent.vue?vue&type=template&id=072c8600&"
import script from "./staffAttachmentsComponent.vue?vue&type=script&lang=js&"
export * from "./staffAttachmentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./staffAttachmentsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports